module.exports = __webpack_public_path__ + "img/bg_services-2.8859de89.jpg";